import {openapi_website_cms_addMarketToFilter, Response200Type, decodeResponse200} from 'src/api_openapi/generated/openapi_website_cms_addMarketToFilter';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type AddMarketType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface AddMarketParamsType {
    display_order: number,
    filter_id: number,
    market_name: string,
    market_slug: string,
    sport_name: string,
}

export const addMarketToFilter = {
    browser: {
        params: (params: AddMarketParamsType): ParamsFetchType<AddMarketParamsType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/add-market',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/add-market',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<AddMarketParamsType>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_addMarketToFilter(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
